import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'dictionarySize',
})
export class DictionarySizePipe implements PipeTransform {
  transform(obj: { [key: string]: unknown }) {
    if (!obj) return 0;

    return Object.keys(obj).length;
  }
}
